module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2n7r4n-b3dc6e0bc421a3a91111a4fcfda84eb0.svg";